export const getFormattedTimeLeft = ({ minLeft, secLeft }) => {
    return `${String(minLeft).padStart(2, '0')}:${String(secLeft).padStart(2, '0')}`;
};
